/* eslint-disable import/no-named-as-default */
/* eslint-disable no-param-reassign */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useCallback } from 'react';
import {
  SomaTextField,
} from '@soma/react';
import { FixedSizeList as List } from 'react-window';

import Checkbox from './Checkbox';

import * as s from './styles';

const SidebarFilters = ({ filters, onFilter, filterNames }) => {
  const [query, setQuery] = useState([]);

  useEffect(() => {
    setQuery(filterNames.map(item => ({
      name: item,
      search: '',
    })));
  }, []);

  const getFilter = (index, value) => {
    setQuery((prevState) => {
      const updatedQuery = [...prevState];
      const currentItem = updatedQuery[index];

      currentItem.search = value;

      return updatedQuery;
    });
  };

  const getFilteredItem = useCallback((index, options) => {
    if (!query[index]?.search) {
      return options.sort((a, b) => (
        Number.isNaN(Number(a.label)) ? (a.label < b.label ? 1 : -1) : (Number(a.label) < Number(b.label) ? 1 : -1)))
        .sort((a, b) => (b.isSelected ? 1 : -1));
    }
    const filtered = options.filter(item => item.label.toString().toLowerCase().includes(query[index].search.toString().toLowerCase()));
    const sorted = filtered.sort((a, b) => (
      Number.isNaN(Number(a.label)) ? (a.label < b.label ? 1 : -1) : (Number(a.label) < Number(b.label) ? 1 : -1)))
      .sort((a, b) => (b.isSelected ? 1 : -1));
    return sorted;
  }, [query]);

  const getFilteredItemCount = useCallback((index, options) => {
    if (!query[index]?.search) {
      return options;
    }
    return options.filter(item => item.label.toString().toLowerCase().includes(query[index].search.toString().toLowerCase()));
  }, [query]);

  const getHeight = name => filterNames.find(item => item.name === name)?.size;

  const handleChange = (categoryIndex, optionValue) => {
    const newArray = [...filters];
    const optionIndex = newArray[categoryIndex].options.findIndex(item => item.value === optionValue);
    newArray[categoryIndex].options[optionIndex].isSelected = !newArray[categoryIndex].options[optionIndex].isSelected;

    onFilter(newArray);
  };

  return (
    <s.Container>
      {filters?.map((item, filterIndex) => (
        <s.Item>
          <s.ItemTitle>{item.title}</s.ItemTitle>
          <SomaTextField
            className="inverse"
            size="sm"
            style={{ marginBottom: '20px' }}
            label="Selecione"
            icon="search"
            aria-label="Selecione um item para filtrar"
            value={query[filterIndex]?.search}
            onSomaChange={e => getFilter(filterIndex, e.detail)}
          />
          {item.options && (
            <List
              className="List"
              height={getHeight(item.name)}
              itemCount={getFilteredItemCount(filterIndex, item.options).length}
              itemData={getFilteredItem(filterIndex, item.options)}
              itemSize={25}
              width="100%"
            >
              {({ data, index, style }) => (
                <Checkbox
                  data={data}
                  index={index}
                  filterIndex={filterIndex}
                  handleChange={handleChange}
                  style={style}
                />
              )}
            </List>
          )}
        </s.Item>
      ))}
    </s.Container>
  );
};
export default SidebarFilters;
